export default "/assets/images/awards-img-03-lg.476ae4de97cbb39d.svg";